/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import caseTopBg from '../../../../../../assets/sme/tpv/sace-bg.png';
import section1Bg from '../../../../../../assets/sme/tpv/section1-bg.png';
import RealCaseContent from '../../components/RealCaseContent';
import CaseTabsContent from '../../components/CaseTabsContent';
import IntegratedServiceList from '../../components/IntegratedServiceList';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );

  const updateComponentState = useUpdateComponentState();
  const handleIntegratedServiceListComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-tpv-section1-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-1">
      <IntegratedServiceList
        id="student-training-tpv-section1-1"
        title={paragraphsSettings.integratedServiceTitle}
        description={paragraphsSettings.description}
        image={section1Bg}
        items={paragraphsSettings.integratedServiceItems}
        onComplete={handleIntegratedServiceListComplete}
      />
      <RealCaseContent
        backgroundImage={caseTopBg}
        headingLines={paragraphsSettings.exampleHeading}
        descTitle={paragraphsSettings.descTitle}
        overviewList={paragraphsSettings.overviewList}
        dataSource={paragraphsSettings.dataSource}
        dataSourceList={paragraphsSettings.dataSourceList}
      />
      <CaseTabsContent item={paragraphsSettings?.case} />
    </div>
  );
};

export default Section1;
